export enum SalesRepsMetricCategories {
  TEAM_ASSIGNED = 'teamAssigned',
  NAME_ADDED = 'nameAdded',
  PHOTO_UPLOADED = 'photoUploaded',
  NOTIFICATIONS_ENABLED = 'notificationsEnabled',
  CALENDAR_CONNECTED = 'calendarConnected',
  CONFERENCE_LINK_ADDED = 'conferenceLinkAdded',
  DEFAULT = '',
}
